import { ShoppingCart } from "@mui/icons-material";
import { AppBar, Badge, Box, IconButton, List, ListItem, Switch, Toolbar, Typography } from "@mui/material";
import { Link, NavLink } from "react-router-dom";

import { useAppSelector } from "../store/configureStore";
import SignedInMenu from "./SignedInMenu";



const rightLinks = [
  {title: 'login', path: '/login'},
  {title: 'register', path: '/register'},
]

const navStyles = 
  {
    color: 'inherit', 
    textDecoration: 'none',
    typography: 'body1',
    '&:hover': {
        color: 'grey.500'
    },
    '&.active': {
        color: 'text.secondary'
    }
}



interface Props {
  darkMode: boolean;
  handleThemeChange: () => void
}

export default function Header({darkMode, handleThemeChange}: Props) {

  const {basket} = useAppSelector(state => state.basket)
  const {user} = useAppSelector(state => state.account)
  const itemCount = basket?.items.reduce((sum, item) => sum + item.quantity, 0)

  return (
    <AppBar position="static" elevation={0} color="secondary">
        <Toolbar sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <Box display='flex' alignItems='center'>
            <Typography variant="h6" component={NavLink} 
                to='/'
                sx={navStyles}
            >
                Home Base Enamels
            </Typography>
            <Switch checked={darkMode} onChange={handleThemeChange} />
        </Box> 
        
            <List sx={{display: 'flex'}}>
                
                {user && user.roles?.includes('Admin') &&
                    (<>
                        <ListItem 
                            component={NavLink}
                            to={'/inventory'}
                            sx={navStyles}
                            >
                            INVENTORY
                        </ListItem>
                        <ListItem 
                        component={NavLink}
                        to={'/allOrders'}
                        sx={navStyles}
                        >
                        ORDERS
                        </ListItem>
                        <ListItem 
                        component={NavLink}
                        to={'/users'}
                        sx={navStyles}
                        >
                        USERS
                        </ListItem>
                    </>
                    )
                     } 
            </List>
            
          <Box display='flex' alignItems='center'>
              <IconButton component={Link} to='/basket' size="large" edge='start' color="inherit" sx={{mr: 2}}>
                      <Badge badgeContent={itemCount} color="primary">
                          <ShoppingCart />
                      </Badge>
                      
                </IconButton>
                {user ? (<SignedInMenu /> ) : (
                    <List sx={{display: 'flex'}}>
                    {rightLinks.map(({title, path}) => (
                        <ListItem 
                            component={NavLink}
                            to={path}
                            key={path}
                            sx={navStyles}
                            >
                            {title.toUpperCase()}
                        </ListItem>
                    ))}
                </List> 
                )}
                
          </Box>

            
        </Toolbar>
    </AppBar>
  )
}